import { apiGet } from './apiClient';

export async function fetchClubCurrency(clubCode) {
  const res = await apiGet(
    `/api/control/clubs/${encodeURIComponent(String(clubCode))}/currency`,
  );
  if (!res.ok) {
    throw new Error(res.error || 'Failed to load club currency');
  }
  return res.data?.data || null;
}

export async function getTenantPublicByClubCode(clubCode) {
  if (!clubCode) {
    throw new Error('Missing club code');
  }
  const res = await apiGet(
    `/api/control/tenants/${encodeURIComponent(String(clubCode))}/public`,
  );
  if (!res.ok) {
    throw new Error(res.error || 'Failed to load tenant branding');
  }
  return res.data?.tenant || null;
}
